export const textTranslations = (section, language, props) => {
    if(language === "english") {
        if(section === "title") {
            return <span>Fellowship. Realigned.</span>
        }
        if(section === "send-a-text-title") {
            return <span>Interested in the path of balance?</span>
        }
        if(section === "send-a-text-subtitle") {
            return "Schedule a Call!"
        }
        if(section === "main-paragraph") {
            return <span>Where <b>fellow travelers</b> become <b>friends</b>.</span>  
        }
        if(section === "main-paragraph-2") {
            return "Across oceans and time zones, voices meet. The Boggler connects you with someone who listens — a real person, not an algorithm — to talk through love, loss, or life. Because friendship can begin with a single conversation."
        }
    } else if(language === "sinhala") {
        if(section === "title") {
            return <span>🌙 ඔබේ පෙම්වතා හෝ පෙම්වතිය ඔබව ප්‍රතික්ෂේප කළාද?</span>
        }
        if(section === "send-a-text-title") {
            return <h2 style={{textAlign: "center", fontSize: "1.5rem"}}>ඔබට සමබරතාවයේ මාර්ගය ඉගෙන ගැනීමට අවශ්‍යද?<br /> obaṭa samabaratāvayē mārgaya igena gænīmaṭa avaśyada?</h2>
        }
        if(section === "send-a-text-subtitle") {
            return <span>බොග්ලර්ට පණිවිඩයක් යවන්න</span>
        }
        if(section === "main-paragraph") {
            return <span><b>පිළිගැනීමේ දූපතට යන ගමනේදී මා සමඟ ඇවිදින්න...</b></span>  
        }
        if(section === "main-paragraph-2") {
            return <span><span className="read-paragraph lucky-font">ඔයා කවදා හරි පෙම්වතෙක් අතින් ප්‍රතික්ෂේප වෙලා තියෙනවද?</span><br />
                <span>මුලෙන් උදුරා ගත්තා...<br />
                දැන් වියළී කුණු වී ඇත...<br />
                විසන්ධි වී ඇති බවක් දැනේ!?</span></span>
        }
    }
}